export default "__VITE_ASSET__CZyf9cx8__"